// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"2c90259a","663":"fe2115c5"}[chunkId] + ".chunk.css";
};